module.exports = __webpack_public_path__ + "static/img/Plakat_Wiederkehr-554x783.1635e54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gruene/Plakat_Wiederkehr-554x783.jpg
// module id = 181
// module chunks = 1